import React from 'react';
import './App.css';
import View from './components/View/View';

function App() {
  return (
    <div className="app">
      <View />
    </div>
  );
}

export default App;
